import { Toggle } from '#features'
import { DevSettings, devSettingsType } from '#settings/constants'
import { useSettings } from 'apprise-frontend-streams/settings/api'
import { createToggles } from 'apprise-fullstack-core/toggle/toggle.ui'


// the global policy, plus the toggles released to all from the Dev settings (apprise-fullstack-core, as dfad).
// logged users get the beta-tester policy (apprise-frontend-iam), guests the core default.
// stored settings come back without module defaults, so enabledFeatures may be absent: the library tolerates it.
// stored names are plain strings, hence the cast: it keeps isFeatureEnabled typed on our toggles.
export const [Toggles, useToggles] = createToggles<Toggle>(() => useSettings<DevSettings>(devSettingsType).enabledFeatures as Toggle[])
